import { render, staticRenderFns } from "./memopelepasanjaminansebagian.vue?vue&type=template&id=bbda33c0&scoped=true&"
import script from "./memopelepasanjaminansebagian.vue?vue&type=script&lang=js&"
export * from "./memopelepasanjaminansebagian.vue?vue&type=script&lang=js&"
import style0 from "./memopelepasanjaminansebagian.vue?vue&type=style&index=0&id=bbda33c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbda33c0",
  null
  
)

export default component.exports